// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { TransferItemRequest } from './transfer-item-request';

/** See com.rev360.pms.api.controller.accounting.TransferInvoiceItemsRequest */
/* istanbul ignore next */
@GandalfModel
export class TransferInvoiceItemsRequest extends GandalfModelBase {

	@GandalfLabel('Include All Items')
	@GandalfValidator({ notNull: { message: 'Include All Items in Transfer is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	includeAllItems!: boolean;

	@GandalfLabel('Invoice')
	@GandalfValidator({ notNull: { message: 'Invoice is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	invoiceId!: number;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfLabel('Payer Type')
	@GandalfProperty({ designType: constants.PayerType })
	payerType!: constants.PayerType | null;

	@GandalfLabel('Person Insurance')
	@GandalfProperty({ designType: Number })
	personInsuranceId!: number | null;

	@GandalfArray(TransferItemRequest)
	transferItems!: TransferItemRequest[];

	@GandalfLabel('Transfer Reference')
	@GandalfProperty({ designType: Number })
	transferReferenceId!: number | null;

	@GandalfLabel('Transfer To Existing Invoice')
	@GandalfProperty({ designType: Number })
	transferToExistingInvoiceId!: number | null;

	@GandalfConstantDecorator(constants.TransferType)
	@GandalfLabel('Transfer Type')
	@GandalfValidator({ notNull: { message: 'Transfer Type is required' } })
	@GandalfProperty({ designType: constants.TransferType, isRequired: true })
	transferType!: constants.TransferType;

	@GandalfLabel('Write-off Reference')
	@GandalfProperty({ designType: Number })
	writeoffReferenceId!: number | null;

}
